import ParticipantSection from './ParticipantSection';

export default ParticipantSection;
